import {
  SubscriptionDetails,
  SuraasaPlusSubscriptionStatus,
} from "api/resources/suraasaPlus/types"
import { isBefore } from "date-fns"

function canGenerateMore(used?: number, allowed?: number): boolean {
  // Case 1: both undefined -> allow user to generate but will get error from backend
  if (used === undefined && allowed === undefined) {
    return true
  }

  // Case 2: allowed is -1 -> This means user has unlimited generations
  if (allowed === -1) {
    return true
  }

  // Case 3: compare if both values exist (normal case)
  if (used !== undefined && allowed !== undefined) {
    return used < allowed
  }

  // Default (This case won't ever be reached in most cases)
  return false
}

function isSubscriptionActive(
  subscriptionDetails?: SubscriptionDetails
): boolean {
  // Case 1: status is active
  if (
    subscriptionDetails?.subscription.status ===
      SuraasaPlusSubscriptionStatus.active ||
    subscriptionDetails?.subscription.status ===
      SuraasaPlusSubscriptionStatus.paymentOverdue
  ) {
    return true
  }

  // Case 2: validThrough is defined -> return true only if it’s still in the future
  if (subscriptionDetails?.subscription.validThrough) {
    return isBefore(
      new Date(),
      new Date(subscriptionDetails.subscription.validThrough)
    )
  }

  // Otherwise not active
  return false
}

export { canGenerateMore, isSubscriptionActive }
